module.exports = __webpack_public_path__ + "img/broadcast-work-icon1.dbd071ce.png";